import React from 'react';
import { Col } from 'antd';

import { StepSection } from './StepSection';
import { StrainIndexTable } from './StrainIndexTable';

import type { StrainIndexReport } from '@/types/StrainIndex';
import type { BeraReportV2ResultStep } from '@/types/Bera';

interface ResultBodyProps {
	steps: BeraReportV2ResultStep[];
	strainIndex?: StrainIndexReport;
}

export function ResultBody({ steps, strainIndex }: Readonly<ResultBodyProps>): JSX.Element {
	return (
		<>
			{steps.map((step) => (
				<Col key={step.id} span={24}>
					<StepSection step={step} />
				</Col>
			))}
			{!!strainIndex && (
				<Col span={24}>
					<StrainIndexTable strainIndex={strainIndex} />
				</Col>
			)}
		</>
	);
}
